import React from 'react';
import _ from "lodash";
import { Container, Row, Col } from "react-bootstrap"

import Layout from "../components/Layout"
import FindOut from "../components/FindOut/FindOut";
import Info from "../components/Info/Info"
import Features from "../components/Features/Features";
import Customer from "../components/Customer/Customer";
import TextImageBlock from "../components/TextImageBlock/TextImageBlock";
import Reviews from "../components/Reviews/Reviews";
import VideoReviews from "../components/Reviews/VideoReviews";
import News from "../components/News/News"
import Journey from "../components/Journey/Journey";
import Banner from "../components/Banner/Banner"
import Counter from "../components/Counter/Counter";
import Team from "../components/Team/Team"
import LocalExperience from "../components/LocalExperience/LocalExperience"
import LinkGroup from "../components/LinkGroup/LinkGroup"
import ManagementServices from "../components/ManagementServices/ManagementServices"
import FeaturedLogo from "../components/FeaturedLogo/FeaturedLogo";
import LeadooScript from "../components/LeadooScript/LeadooScript";

import TilesBlock from "../components/TilesBlock/Tiles";
import ServiceTiles from "../components/TilesBlock/ServiceTiles";
import TrustpilotReviews from "../components/TrustpilotReviews/TrustpilotReviews";
import StudentHub from "../components/StudentHub/StudentHub";
import TeamThink from "../components/Reviews/TeamThink";
import WhyChoose from "../components/Counter/WhyChoose";
import BannerSlider from "../components/BannerSlider/Slider";
import FAQ from "../components/Faq/Faq"
import HolidayHomes from "../components/HolidayHomes/HolidayHomes"
import ImageTextCarousal from "../components/ImageTextCarousal/ImageTextCarousal"

import {leadooPageSlot} from "../common/constant";


const PageTemplate = (props) =>{


  var GQLPage = props.GQLPage;
  var GQLModules = props.GQLModules;

  var isJourneySec = _.find(GQLModules, function (o) { return o.__typename === "GLSTRAPI_ComponentComponentsShowPropertyJourney" && o.show });

  //console.log("GQLModules ==>", GQLModules);

  let pathname = GQLPage?.menu?.slug ? GQLPage?.menu?.slug.replace(/-/g, '_') : "";

  //console.log("pathname =>", pathname, leadooPageSlot[pathname]);

  return(
    <Layout seo_meta={GQLPage.seo_meta} isJourneySec={isJourneySec} menu_slug={GQLPage?.menu?.slug} popular_search={GQLPage?.menu?.popular_search} GQLPage={GQLPage}>
      
        {GQLPage?.banner_section?.banner_image && <Banner banner_section = {GQLPage.banner_section} GQLPage={GQLPage}/> }

        {/* {leadooPageSlot?.sell_test && 
            <ld-slot name={leadooPageSlot[pathname]}></ld-slot>
        } */}

        {GQLModules?.length > 0 && GQLModules?.map((Module, index) => {
            return(
                <>
                    {(!GQLPage?.banner_section?.banner_image && Module?.__typename === "GLSTRAPI_ComponentComponentsSliderComponent") && <BannerSlider key={Module} Module={Module} GQLPage={GQLPage}/> }

                    {Module.__typename === "GLSTRAPI_ComponentComponentsHolidayHomesComponent" && <HolidayHomes key={Module} Module={Module}/> }

                    {Module?.__typename === "GLSTRAPI_ComponentComponentsClientLogosComponent" && <FeaturedLogo key={Module} Module={Module} /> }

                    {Module.__typename === "GLSTRAPI_ComponentComponentsIntroSection" && <FindOut key={Module} Module={Module} /> }                    

                    {Module.__typename === "GLSTRAPI_ComponentComponentsHomeTilesComponent" && <Info key={Module} Module={Module} GQLPage={GQLPage} pathname={pathname} leadooPageSlot={leadooPageSlot}/> }

                    {Module?.__typename === "GLSTRAPI_ComponentComponentsTilesBoxComponent" && <TilesBlock key={Module} Module={Module} GQLPage={GQLPage} /> }

                    {Module.__typename === "GLSTRAPI_ComponentComponentsImageTextCarousel" && <ImageTextCarousal key={Module} Module={Module} strapi_id={GQLPage.id}/> }

                    {Module?.__typename === "GLSTRAPI_ComponentComponentsServiceTilesComponent" && <ServiceTiles key={Module} Module={Module} GQLPage={GQLPage} /> }

                    {Module.__typename === "GLSTRAPI_ComponentComponentsWhyChooseComponent" && <WhyChoose key={Module} Module={Module} /> }

                    {Module.__typename === "GLSTRAPI_ComponentComponentsTeamThinkComponent" && <TeamThink key={Module} Module={Module} />}

                    {Module.__typename === "GLSTRAPI_ComponentComponentsTrustpilotComponent" && <TrustpilotReviews key={Module} Module={Module} />}

                    {Module.__typename === "GLSTRAPI_ComponentComponentsStudentHubComponent" &&  <StudentHub key={Module} Module={Module} GQLPage={GQLPage}/>}

                    {Module.__typename === "GLSTRAPI_ComponentComponentsShowFeaturedProperty" && Module.show && <Features key={Module} Module={Module} menu_slug={GQLPage?.menu?.slug}/> }

                    {Module.__typename === "GLSTRAPI_ComponentComponentsVideoSection" &&  <Customer key={Module} Module={Module} GQLPage={GQLPage}/>}

                    {Module.__typename === "GLSTRAPI_ComponentComponentsTextBlockWithImage" &&  <TextImageBlock key={Module} Module={Module} GQLPage={GQLPage}/>}

                    {Module.__typename === "GLSTRAPI_ComponentComponentsShowStatisticsSection" && Module.show &&  <Counter key={Module} Module={Module} pathname={pathname} leadooPageSlot={leadooPageSlot}/>}

                    {Module.__typename === "GLSTRAPI_ComponentComponentsShowMeetTeam" && Module.show &&  <Team key={Module} Module={Module} category={Module.team_department} />}

                    {Module.__typename === "GLSTRAPI_ComponentComponentsLocalExperience" && <LocalExperience key={Module} Module={Module} GQLPage={GQLPage}/>}

                    {Module.__typename === "GLSTRAPI_ComponentComponentsShowCustomerReviews" && Module.show && <Reviews key={Module} Module={Module}/> }

                    {Module?.__typename === "GLSTRAPI_ComponentComponentsLeadooChatComponent" && <LeadooScript key={Module} Module={Module}/> }

                    {Module.__typename === "GLSTRAPI_ComponentComponentsCustomerVideoReviews" && Module?.customer_video_review.length > 0 && <VideoReviews key={Module} Module={Module?.customer_video_review[0]} GQLPage={GQLPage}/> }

                    {Module.__typename === "GLSTRAPI_ComponentComponentsShowNewsInsight" && Module.show && <News key={Module} Module={Module}/> }

                    {Module.__typename === "GLSTRAPI_ComponentComponentsPropertyServiceManagement" && <ManagementServices key={Module} Module={Module}/> }


                    {Module.__typename ==="GLSTRAPI_ComponentComponentsFaq" && 
                        <Container>
                            <Row>
                                <Col><FAQ key={Module} Module={Module} /></Col>
                            </Row>
                        </Container>
                    }

                    {Module.__typename === "GLSTRAPI_ComponentComponentsWhatAreYouLookingFor" && <LinkGroup key={Module} Module={Module}/> }
                    

                    {Module.__typename === "GLSTRAPI_ComponentComponentsShowPropertyJourney" && Module.show && <Journey key={Module} />}
                </>                
            )
        })}
                
    </Layout>
  )

}

export default PageTemplate

